import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Signup() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Password must be 6+ chars"); return; }
    setLoading(true);
    try {
      const u = await register(name, email, password);
      toast.success(`Welcome, ${u.name.split(" ")[0]}!`);
      nav("/");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Sign up failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16" data-testid="signup-page">
      <span className="tag-sticker bg-pink text-xl rotate-tilt-r inline-block mb-2">join the club</span>
      <h1 className="font-display text-5xl uppercase">Sign up</h1>
      <form onSubmit={submit} className="mt-8 brut p-6 flex flex-col gap-4">
        <label className="font-bold uppercase tracking-wider text-sm">Name
          <input required value={name} onChange={(e) => setName(e.target.value)} className="brut-input w-full mt-1 normal-case" data-testid="signup-name" />
        </label>
        <label className="font-bold uppercase tracking-wider text-sm">Email
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="brut-input w-full mt-1 normal-case" data-testid="signup-email" />
        </label>
        <label className="font-bold uppercase tracking-wider text-sm">Password
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="brut-input w-full mt-1 normal-case" data-testid="signup-password" />
        </label>
        <button type="submit" disabled={loading} className="brut-btn bg-orange text-white py-3 mt-2" data-testid="signup-submit">
          {loading ? "Signing up…" : "Create account"}
        </button>
      </form>
      <p className="mt-6 text-center">Already have one? <Link className="font-bold underline decoration-[3px] decoration-[#FF5A00]" to="/login">Log in</Link></p>
    </div>
  );
}
